import { useCallback, useState } from "react";
import { ExpandedState } from "@tanstack/react-table";

/**
 * Expanded rows for a report that opens fully expanded. Every new
 * `expandAllState` (fresh report data, filters, grouping) re-expands all rows;
 * `toggleAll` collapses everything or expands it back.
 */
export function useExpandAllState(expandAllState: ExpandedState) {
    const [expanded, setExpanded] = useState<ExpandedState>(expandAllState);
    const [prevExpandAllState, setPrevExpandAllState] =
        useState(expandAllState);
    if (expandAllState !== prevExpandAllState) {
        setPrevExpandAllState(expandAllState);
        setExpanded(expandAllState);
    }

    const isCollapsed = Object.keys(expanded).length === 0;

    const toggleAll = useCallback(() => {
        setExpanded((current) =>
            Object.keys(current).length === 0 ? expandAllState : {},
        );
    }, [expandAllState]);

    return { expanded, setExpanded, isCollapsed, toggleAll };
}
